import { api } from "api";
const url = 'bank_accounts';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_ACCOUNT = 'LOADER_ACCOUNT';
const SET_DATA_ACCOUNT = 'SET_DATA_ACCOUNT';
const SET_PAGE_ACCOUNT = 'SET_PAGE_ACCOUNT';
const SET_UPDATE_DATA_ACCOUNT ='SET_UPDATE_DATA_ACCOUNT';
const SET_BUSCADOR_ACCOUNT = 'SET_BUSCADOR_ACCOUNT';
const SET_FILTRO_ACCOUNT = 'SET_FILTRO_ACCOUNT';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_ACCOUNT, cargando: true});
    const store = getStore();
    const search = store.bankAccounts.buscador;
    const filtro = store.bankAccounts.filtro_bankAccounts;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_ACCOUNT, data});
            dispatch({type: SET_PAGE_ACCOUNT, page});
        }
        dispatch({type: LOADER_ACCOUNT, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_ACCOUNT, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/bank-accounts'))
        }
    }).then((data) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_ACCOUNT, updateData: data});
            dispatch(initializeForm('bankAccount', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.bankAccount.values;
    dispatch({type: LOADER_ACCOUNT, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false})
        Swal('Éxito', 'Se ha creado la cuenta bancaria.', 'success')
        .then(() => {
            dispatch(push('/bank-accounts'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_ACCOUNT, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.bankAccount.values);
    dispatch({type: LOADER_ACCOUNT, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/bank-accounts'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/bank-accounts/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_ACCOUNT, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_ACCOUNT, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_ACCOUNT, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_ACCOUNT, filtro_bankAccounts: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_ACCOUNT]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_ACCOUNT]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_ACCOUNT]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_ACCOUNT]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_ACCOUNT]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_ACCOUNT]: (state, { filtro_bankAccounts }) => {
        return {...state, filtro_bankAccounts }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_bankAccounts: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
